import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/address-card': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M528 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-480c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h480zM528 432v-352h-480v352h480zM208 256c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zM118.4 384c-12.4 0-22.4-8.6-22.4-19.2v-19.2c0-31.8 30.1-57.6 67.2-57.6 11.4 0 17.9 8 44.8 8 26.1 0 34-8 44.8-8 37.1 0 67.2 25.8 67.2 57.6v19.2c0 10.6-10 19.2-22.4 19.2h-179.2zM360 320c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-112zM360 256c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-112zM360 192c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-112z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/address-card.js
// module id = 1685
// module chunks = 0